import React from "react";
import Link from "gatsby-link";
import {
  LinkedinShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinIcon
} from "react-share";
import Content from "../components/layout/Content";
import gems from "./img/gems-group.svg";
import indy from "../components/img/indy-avatar.svg";

const handleTwitterClick = () => {
  if (typeof ga === "function") {
    ga("send", "event", {
      eventCategory: "Social",
      eventAction: "click",
      eventLabel: "Twitter Share"
    });
  }
};

const handleLinkedinClick = () => {
  if (typeof ga === "function") {
    ga("send", "event", {
      eventCategory: "Social",
      eventAction: "click",
      eventLabel: "LinkedIn Share"
    });
  }
};

const completed = ({ transition }) => (
  <div
    className="Shell Shell--completed"
    style={transition && transition.style}
  >
    <Content header>
      <div className="container">
        <div className="ContentBox">
          <article className="Article Article--grattis">
            <figure className="GemGroup">
              <img src={gems} width="100%" height="auto" />
            </figure>
            <header className="Article__header">
              <h1>Grattis!</h1>
            </header>
            <section className="Article__section">
              <p>
                Du har förfinat ditt sätt att uttrycka dig och gjort första
                stegen i en behovsanalys. Nu kan du uttrycka dig mer precist i
                annonser och intervjuer!
              </p>
              <p
                style={{
                  fontWeight: "600",
                  marginBottom: 22,
                  fontSize: 12,
                  lineHeight: "22px"
                }}
              >
                Vill du få ett skarpt verktyg för behovsanalys?
              </p>

              <Link
                style={{ marginBottom: 56 }}
                className="button button--round button--accent button--large"
                to="/resources/"
              >
                Ge mig ett verktyg
              </Link>
            </section>
          </article>
        </div>
      </div>
    </Content>
    <div className="ShareBar">
      <div className="ShareBar__row">
        <section className="ShareBar__section">
          <span className="ShareBar__section__label">
            Tipsa en vän <br /> om spelet:
          </span>
          <TwitterShareButton
            beforeOnClick={() => handleTwitterClick()}
            title="Upptäck arbetsmarknadens vanligaste floskler och lär dig sticka ut i mängden. Spela Jakten på den oslipade diamanten!"
            url="https://jakten.arbetsgivare.nu"
            className="ShareBar__button"
          >
            <TwitterIcon
              size={36}
              round
              iconBgStyle={{ fill: "#fff" }}
              logoFillColor="#00005a"
            />
          </TwitterShareButton>
          <LinkedinShareButton
            beforeOnClick={() => handleLinkedinClick()}
            url="https://jakten.arbetsgivare.nu"
            title="Spela Jakten på den oslipade diamanten!"
            description="Upptäck arbetsmarknadens vanligaste floskler och lär dig sticka ut i mängden."
            className="ShareBar__button"
          >
            <LinkedinIcon
              iconBgStyle={{ fill: "#fff" }}
              logoFillColor="#00005a"
              size={36}
              round
            />
          </LinkedinShareButton>
        </section>
      </div>
    </div>
  </div>
);

export default completed;



// WEBPACK FOOTER //
// ./src/pages/completed.js